module.exports = __webpack_public_path__ + "img/qrs.c65727f3.jpg";